import React from 'react';

interface RadioButtonOptions {
  id: string;
  label: string;
  value?: string;
}

interface RadioButtonGroupProps {
  name: string;
  options: RadioButtonOptions[];
  required?: boolean;
  // label?: string; // Uncomment if you want to use a label
}

export const getRadioGroupValue = (name) => {
  const radioGroup = document.querySelector(`input[name="${name}"]:checked`);
  return radioGroup ? (radioGroup as HTMLInputElement).value : '';
};

export function RadioButtonGroup({ name, options }: RadioButtonGroupProps) {
  return (
    <div className="radio-button-group">
      {/* {label && (
        <label className="input-label" htmlFor={id}>
          {label}
        </label>
      )} */}
      {options.map((option) => (
        <label key={option.id} className="radio-button" htmlFor={option.id}>
          <input id={option.id} type="radio" name={name} value={option.value ?? option.id} />
          <span>{option.label}</span>
        </label>
      ))}
    </div>
  );
}
